/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portalnotify_RetryInputs */

const en_portalnotify_retry = /** @type {(inputs: Portalnotify_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try again`)
};

/** @type {(inputs: Portalnotify_RetryInputs) => LocalizedString} */
const ar_portalnotify_retry = en_portalnotify_retry;

/** @type {(inputs: Portalnotify_RetryInputs) => LocalizedString} */
const he_portalnotify_retry = en_portalnotify_retry;

/** @type {(inputs: Portalnotify_RetryInputs) => LocalizedString} */
const ur_portalnotify_retry = en_portalnotify_retry;

/** @type {(inputs: Portalnotify_RetryInputs) => LocalizedString} */
const es_portalnotify_retry = en_portalnotify_retry;

/** @type {(inputs: Portalnotify_RetryInputs) => LocalizedString} */
const fr_portalnotify_retry = en_portalnotify_retry;

/** @type {(inputs: Portalnotify_RetryInputs) => LocalizedString} */
const de_portalnotify_retry = en_portalnotify_retry;

/** @type {(inputs: Portalnotify_RetryInputs) => LocalizedString} */
const pt_portalnotify_retry = en_portalnotify_retry;

/** @type {(inputs: Portalnotify_RetryInputs) => LocalizedString} */
const hi_portalnotify_retry = en_portalnotify_retry;

/** @type {(inputs: Portalnotify_RetryInputs) => LocalizedString} */
const bn_portalnotify_retry = en_portalnotify_retry;

/**
* | output |
* | --- |
* | "Try again" |
*
* @param {Portalnotify_RetryInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const portalnotify_retry = /** @type {((inputs?: Portalnotify_RetryInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portalnotify_RetryInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_portalnotify_retry(inputs)
	if (locale === "he") return he_portalnotify_retry(inputs)
	if (locale === "ur") return ur_portalnotify_retry(inputs)
	if (locale === "es") return es_portalnotify_retry(inputs)
	if (locale === "fr") return fr_portalnotify_retry(inputs)
	if (locale === "de") return de_portalnotify_retry(inputs)
	if (locale === "pt") return pt_portalnotify_retry(inputs)
	if (locale === "hi") return hi_portalnotify_retry(inputs)
	if (locale === "bn") return bn_portalnotify_retry(inputs)
	return /** @type {LocalizedString} */ ("Try again")
});